<template>
    <div data-testid="edit-group-buttons">
        <div class="flex items-center">
            <div
                class="flex items-center cursor-pointer text-steel hover:text-primary"
                data-testid="button-add-widgets"
                @click="tryAddWidgets"
            >
                <IconAddWidget />
                <div class="mx-2">
                    {{ $t('widget.addNewWidgets') }}
                </div>
            </div>
            <template v-if="getLayoutType === layoutTypes.TABBED">
                <div
                    v-if="!$rtl.isRTL"
                    class="flex"
                >
                    <span @click="onMove('up')" data-testid="button-move-left">
                        <IconDirLeft
                            class="cursor-pointer text-steel hover:text-primary"
                        />
                    </span>
                    <span @click="onMove('down')" data-testid="button-move-right">
                        <IconDirRight
                            class="cursor-pointer mx-2 text-steel hover:text-primary"
                        />
                    </span>
                </div>
                <div
                    v-else
                    class="flex"
                >
                    <span @click="onMove('up')" data-testid="button-move-left">
                        <IconDirRight
                            class="cursor-pointer text-steel mx-2 hover:text-primary"
                        />
                    </span>
                    <span @click="onMove('down')" data-testid="button-move-right">
                        <IconDirLeft
                            class="cursor-pointer text-steel hover:text-primary"
                        />
                    </span>
                </div>
            </template>
            <template v-if="getLayoutType === layoutTypes.LIST">
                <el-tooltip
                    :content="$t('tooltip.reorder.dashboard.layout')"
                    class="item"
                    :open-delay="openDelay"
                    effect="dark"
                    placement="top"
                >
                    <div
                        class="flex items-center hover:text-primary cursor-pointer"
                        data-testid="button-reorder-groups"
                        @click="tryReorderWidgetGroups"
                    >
                        <IconDirUp class="text-steel" />
                        <IconDirDown class="text-steel" />
                    </div>
                </el-tooltip>
            </template>
            <el-tooltip
                :content="$t('tooltip.remove.group')"
                class="item"
                effect="dark"
                :open-delay="openDelay"
                placement="top"
            >
                <span @click="$emit('remove-group', widgetGroup)" data-testid="button-remove-group">
                    <IconDelete
                        class="text-red cursor-pointer hover:text-red-focus mx-2"
                    />
                </span>
            </el-tooltip>
        </div>
        <ReorderWidgetGroupDialog
            v-if="showReorderLayoutDialog"
            :visible="showReorderLayoutDialog"
            :widget-group-list="activeDashboardData.WidgetGroupList"
            @on-cancel="showReorderLayoutDialog = false"
            @on-submit="onSubmit"
            @reorder-widgets-in-modal="reorderWidgetsInModal"
            @update:visible="($evt) => showReorderLayoutDialog = $evt"
        />
    </div>
</template>
<script>
import { layoutTypes } from '@/enum/layout'

export default {
    inheritAttrs: false,
    name: 'EditGroupButtons',
    components: {
        ReorderWidgetGroupDialog: () => import('@/components/LayoutRendering/ReorderWidgetGroupDialog.vue')
    },
    props: {
        widgetGroup: {
            type: Object,
            default: () => ({}),
        },
        activeDashboardData: {
            type: Object,
            default: () => ({}),
        },
        activeWidgetGroupId: {
            type: [ String, Number ]
        }
    },
    data () {
        return {
            openDelay: 200,
            showAddWidgetDialog: false,
            showReorderLayoutDialog: false,
            layoutTypes,
            showConfirmDialog: false,
            selectedCategory: null,
            addWidgetOpened: false
        }
    },
    computed: {
        getLayoutType () {
            return localStorage.getItem('layout-type') || layoutTypes.TABBED
        }
    },
    methods: {
        tryAddWidgets () {
            this.$emit('add-new-widget', this.widgetGroup)
        },
        onMove (direction) {
            const objToEmit = {
                direction: direction,
                widgetGroup: this.widgetGroup,
            }
            this.$emit('on-reorder-widget-group', objToEmit)
        },
        tryReorderWidgetGroups () {
            this.showReorderLayoutDialog = !this.showReorderLayoutDialog
        },
        reorderWidgetsInModal () {
            this.onMove('move')
        },
        onSubmit (data) {
            this.showReorderLayoutDialog = false
            this.$set(this.activeDashboardData, 'WidgetGroupList', data)
        }
    }
}
</script>
